import authoring from '@sstdev/lib_metadata-authoring';
import { uiRuntimeConfig, constants } from 'lib_ui-services';

// Browser presentation stays here; browser and server share the same compiler.
export default function combineMetadata(namespaces, profileMenu, navigation, pages, options, dispatch) {
    return authoring.combineMetadata(
        namespaces,
        profileMenu,
        navigation,
        pages,
        options,
        (message, blockId, overrides = {}) =>
            dispatch(
                {
                    message,
                    blockId,
                    timeout: uiRuntimeConfig.getNotificationTimeoutFormError(),
                    addToList: true,
                    isError: true,
                    variant: 'error',
                    type: constants.notificationTypes.TOAST,
                    ...overrides
                },
                { verb: 'pop', namespace: 'application', relation: 'notification' }
            )
    );
}
